"use client";

import { Heading, Stack } from "@biblioteksentralen/react";
import { LCWork, LCWorkParams } from "@libry-content/integrations";
import { DefaultContainer } from "../../../../../../../components/ContentContainer";
import { DefaultPageLayout } from "../../../../../../../components/layout/DefaultPageLayout";
import CollectionViewBanner from "../../../../../../../searchAndCollection/components/CollectionViewBanner";
import ItemGrid from "../../../../../../../searchAndCollection/components/works/ItemGrid";
import { useTranslation } from "../../../../../../../utils/hooks/useTranslation";
import { getCollectionMetadata, sortSeries } from "./utils";

type Props = {
  seriesWorkId: string;
  worksParams: LCWorkParams[];
};

const SeriesClientSide = ({ seriesWorkId, worksParams }: Props) => {
  const { t } = useTranslation();
  const works = worksParams.map((params) => new LCWork(params));
  const collectionMetadata = getCollectionMetadata(works, seriesWorkId);
  const worksSortedByNumberInSeries = sortSeries(works, seriesWorkId);

  const hasNumberedWorks = worksSortedByNumberInSeries.numberedWorks.length > 0;
  const hasNonNumberedWorks = worksSortedByNumberInSeries.nonNumberedWorks.length > 0;

  return (
    <DefaultPageLayout>
      <DefaultContainer>
        <Stack gap="2rem">
          <CollectionViewBanner
            worksSortedByNumberInSeries={worksSortedByNumberInSeries}
            collectionMetadata={collectionMetadata}
          />
          {hasNumberedWorks && <ItemGrid items={worksSortedByNumberInSeries.numberedWorks} as="ol" gap="1rem" />}
          {hasNumberedWorks && hasNonNumberedWorks && (
            <Heading as={"h3"} fontSize="3xl" marginTop="0 !important">
              {t("Andre verk relatert til serien")}
            </Heading>
          )}
          {hasNonNumberedWorks && <ItemGrid items={worksSortedByNumberInSeries.nonNumberedWorks} as="ul" gap="1rem" />}
        </Stack>
      </DefaultContainer>
    </DefaultPageLayout>
  );
};

export default SeriesClientSide;
